import { FilterTable } from "@/features/FilterTable/FilterTable";
import { Field } from "@/features/FilterTable/types";
import { dateSchema, parseToDateValue } from "@/features/FormCard/utils";
import { z } from "zod";
import { Clients } from "@/lib/clients";
import { Tables } from "@/gen/tableNames/tables";
import { useTranslation } from "react-i18next";

const filterC7PositionsSchema = z.object({
  date_from: z
    .preprocess((val) => parseToDateValue(val as string), dateSchema)
    .optional(),
  date_to: z
    .preprocess((val) => parseToDateValue(val as string), dateSchema)
    .optional(),
  strategy_from_id_equals: z.string().optional(),
  strategy_to_id_equals: z.string().optional(),
  strategy_from_name_contains: z.string().optional(),
  strategy_to_name_contains: z.string().optional(),
  strategy_to_isin_contains: z.string().optional(),
  strategy_to_code_contains: z.string().optional(),
});

export type FilterC7PositionsSchema = z.infer<typeof filterC7PositionsSchema>;

export function FilterC7Positions() {
  const { t } = useTranslation("tables");
  const fields: Field[] = [
    {
      name: "date",
      type: "dateRange",
      label: t("c7_positions.searchbox.date", { defaultValue: "Date" }),
      from: { name: "date_from" },
      to: { name: "date_to" },
      col_span: 2,
    },
    {
      name: "strategy_from_id_equals",
      label: t("c7_positions.searchbox.strategy_from_id_equals", { defaultValue: "Strategy from ID" }),
      type: "input",
      input_type: "number",
    },
    {
      name: "strategy_from_name_contains",
      label: t("c7_positions.searchbox.strategy_from_name_contains", { defaultValue: "Strategy from name" }),
      type: "input",
    },
    {
      name: "strategy_to_id_equals",
      label: t("c7_positions.searchbox.strategy_to_id_equals", { defaultValue: "Strategy to ID" }),
      type: "input",
      input_type: "number",
    },
    {
      name: "strategy_to_name_contains",
      label: t("c7_positions.searchbox.strategy_to_name_contains", { defaultValue: "Strategy to name" }),
      type: "input",
    },
    {
      name: "strategy_to_isin_contains",
      label: t("c7_positions.searchbox.strategy_to_isin_contains", { defaultValue: "Strategy to ISIN" }),
      type: "input",
    },
    {
      name: "strategy_to_code_contains",
      label: t("c7_positions.searchbox.strategy_to_code_contains", { defaultValue: "Strategy to code" }),
      type: "input",
    },
  ];
  return (
    <FilterTable
      schema={filterC7PositionsSchema}
      client={Clients.C7}
      tableName={Tables.C7_POSITIONS}
      fields={fields}
      columns={2}
    />
  );
}
